export class GetProviderSearchFilterResponse {
    affiliationList: string[] = [];
    languageList: string[] = [];
    genderList: string[] = [];
    specialtyList: string[] = [];
    onlineSchedulingList: string[] = [];
}

export class ProviderSearchFilters {

    constructor(providerSearchFilterResponse: GetProviderSearchFilterResponse) {
        this.specialtyList = providerSearchFilterResponse.specialtyList.map(value => {
            const filter = new SearchFilter()
            filter.value = value;
            filter.isSelected = false;
            return filter;
        });
        
        this.onlineSchedulingList = providerSearchFilterResponse.onlineSchedulingList.map(value => {
            const filter = new SearchFilter()
            filter.value = value;
            filter.isSelected = false;
            return filter;
        });

        this.affiliationList = providerSearchFilterResponse.affiliationList.map(value => {
            const filter = new SearchFilter()
            filter.value = value;
            filter.isSelected = false;
            return filter;
        });
        
        this.genderList = providerSearchFilterResponse.genderList.map(value => {
            const filter = new SearchFilter()
            filter.value = value;
            filter.isSelected = false;
            return filter;
        });

        this.languageList = providerSearchFilterResponse.languageList.map(value => {
            const filter = new SearchFilter()
            filter.value = value;
            filter.isSelected = false;
            return filter;
        });       
    }

    providerName: string = '';
    affiliationList: SearchFilter[] = [];
    languageList: SearchFilter[] = [];
    genderList: SearchFilter[] = [];
    specialtyList: SearchFilter[] = [];
    onlineSchedulingList: SearchFilter[] = [];
    location: string = '';
    distanceInMiles: number = 15;
}

// export class GetLocationSearchFilterResponse {
//     serviceList: string[] = [];
//     typeList: string[] = [];
// }

// export class LocationSearchFilters {
   
//     constructor(locationSearchFilterResponse: GetLocationSearchFilterResponse) {
//         this.serviceList = locationSearchFilterResponse.serviceList.map(value => {
//             const filter = new SearchFilter()
//             filter.value = value;
//             filter.isSelected = false;
//             return filter;
//         });       

//         this.typeList = locationSearchFilterResponse.typeList.map(value => {
//             const filter = new SearchFilter()
//             filter.value = value;
//             filter.isSelected = false;
//             return filter;
//         });
//     }

//     locationName: string = '';
//     serviceList: SearchFilter[] = [];
//     typeList: SearchFilter[] = [];
//     location: string = '';
//     distanceInMiles: number = 15;
// }

export class SearchFilter {
    value: string = '';
    isSelected: boolean = false;
}